import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../../services/locale/locale.service';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

@Pipe({
    name: 'localCurrency',
})
export class LocalCurrencyPipe implements PipeTransform {
    public constructor(private readonly localeService: LocaleService) {}

    public transform(value: number): unknown {
        return formatCurrency(
            value,
            this.localeService.locale,
            getCurrencySymbol(this.localeService.getCurrencyLocalCode(), 'narrow'),
        );
    }
}
